import { ActivityInterface } from "@interfaces/activities/activities.interface";
import { CategoriesApi } from "@interfaces/categories/categories.enum";
import { AttendeeInterface, TutorInterface } from "@interfaces/checkout/checkout.interface";
import { ModelInterface } from "@interfaces/global/model.interface";
import { ScheduleInterface, SessionInterface } from "@interfaces/sessions/sessions.interface";
import { UserInterface } from "@interfaces/user/user.interface";

export interface ReservationInterface extends ModelInterface {
  activity: ActivityInterface;
  activityId: string;
  category: CategoriesApi;
  child: AttendeeInterface;
  code: string;
  createdAt: Date;
  deletedAt: Date
  id: string;
  numOfChilds?: number, 
  price: number;
  reservationsQuantity: number,
  responsibles: TutorInterface[];
  scheduleId: string;
  schedules: ScheduleInterface[];
  session: SessionInterface;
  sessionId: string;
  status: ReservationStates;
  updatedAt: Date;
  user?: UserInterface,
  userId?: string;
  ticket?: string;
  schedule?: ScheduleInterface;
}


/* 
export interface ReservationInterface extends ModelInterface {
  id: string;
  code: string;
  status: ReservationStates;
  price: number;
  session: SessionInterface;
  schedules: ScheduleInterface[];
  responsibles: TutorInterface[];
  activity: ActivityInterface;
  reservationsQuantity: number,
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date
} */

export interface ReservationsDeleteInterface extends ModelInterface {
  sessionId: string;
  reservationsIds: string[];
  scheduleId?: string;
}

export enum ReservationStates {
  PENDING= 'PENDING',
  CONFIRMED = 'CONFIRMED',
  CANCELED = 'CANCELED',
}